import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface Message {
  type: 'success' | 'danger'
  text: string | string[]
}

interface MessageState extends Message {
  show: boolean
}

interface Popup {
  content: JSX.Element | null
}

interface PopupState extends Popup {
  show: boolean
}

interface AlertState extends Message {
  show?: boolean
}

interface UtilitiesState {
  disableScroll: boolean
  message: MessageState
  popup: PopupState
  loadingScreen: boolean
  screenBlock: boolean
  alert: AlertState
  errorMessage: string
}

const initialState: UtilitiesState = {
  disableScroll: false,
  message: {
    type: 'success',
    text: '',
    show: false
  },
  popup: {
    content: null,
    show: false
  },
  loadingScreen: false,
  screenBlock: false,
  alert: {
    type: 'danger',
    text: '',
    show: false
  },
  errorMessage: ''
}

const utilitiesSlice = createSlice({
  name: 'utilities',
  initialState,
  reducers: {
    showMessage: (state, action: PayloadAction<Message>) => ({
      ...state,
      message: {
        ...action.payload,
        show: true
      }
    }),
    hideMessage: (state) => ({
      ...state,
      message: {
        ...state.message,
        show: false
      }
    }),
    showPopup: (state, action: PayloadAction<Popup>) => ({
      ...state,
      disableScroll: true,
      popup: {
        ...action.payload,
        show: true
      }
    }),
    hidePopup: (state) => ({
      ...state,
      disableScroll: false,
      popup: {
        ...state.popup,
        show: false
      }
    }),
    showLoadingScreen: (state, action: PayloadAction<boolean>) => ({
      ...state,
      loadingScreen: action.payload
    }),
    showScreenBlock: (state, action: PayloadAction<boolean>) => ({
      ...state,
      screenBlock: action.payload
    }),
    showAlert: (state, action: PayloadAction<AlertState>) => ({
      ...state,
      alert: {
        ...action.payload,
        show: true
      }
    }),
    hideAlert: (state) => ({
      ...state,
      alert: {
        ...state.alert,
        show: false
      }
    }),
    showErrorMessage: (state, action: PayloadAction<string>) => ({
      ...state,
      errorMessage: action.payload
    }),
    hideErrorMessage: (state) => ({
      ...state,
      errorMessage: ''
    }),
    togglePageScroll: (state, action: PayloadAction<boolean>) => ({
      ...state,
      disableScroll: action.payload
    })
  }
})

export const {
  showMessage,
  hideMessage,
  showPopup,
  hidePopup,
  showLoadingScreen,
  showScreenBlock,
  showAlert,
  hideAlert,
  showErrorMessage,
  hideErrorMessage,
  togglePageScroll
} = utilitiesSlice.actions
export default utilitiesSlice.reducer
